import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Logo } from "../components/Logo";
import apiClient from "../utils/api-client";

const Unsubscribe = () => {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [templateName, setTemplateName] = useState("");
  const [scope, setScope] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!token) {
      setError("Dieser Abmeldelink ist unvollständig.");
      return;
    }
    let cancelled = false;
    apiClient
      .previewUnsubscribe(token)
      .then((preview) => {
        if (cancelled) {
          return;
        }
        setScope(preview.scope);
        setTemplateName(preview.template_name || "");
      })
      .catch(() => {
        if (!cancelled) {
          setError("Dieser Abmeldelink ist ungültig.");
        }
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  const confirm = async () => {
    setSubmitting(true);
    try {
      await apiClient.applyUnsubscribe(token);
      setDone(true);
    } catch {
      setError("Die Abmeldung konnte nicht gespeichert werden.");
    } finally {
      setSubmitting(false);
    }
  };

  const description =
    scope === "all"
      ? "Du meldest dich von allen Benachrichtigungen ab."
      : `Du meldest dich von „${templateName || "dieser Benachrichtigung"}“ ab.`;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Logo className="max-w-full" />
        <h2 className="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
          Benachrichtigung abmelden
        </h2>
        <div className="mt-6 text-center text-sm leading-5 text-gray-700">
          {error !== "" && <p>{error}</p>}
          {error === "" && done && <p>Du erhältst diese Benachrichtigung nicht mehr.</p>}
          {error === "" && !done && scope === "" && <p>Link wird geprüft…</p>}
          {error === "" && !done && scope !== "" && (
            <>
              <p>{description}</p>
              <button
                type="button"
                disabled={submitting}
                onClick={confirm}
                className="mt-6 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-500 disabled:opacity-50"
              >
                Abmelden
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
